import SuperRepository from '../superRepository'

export default new (class BudgetPlanRepository extends SuperRepository {
  baseUri() {
    return 'budget_report/report'
  }
  budgetPlanner = async ({ signal, ...data }) => this.httpClient().post(`budget_report/planned_budget`, data, { signal })
  import = async (data, date, params) =>
    this.httpClient().postFile(`planned_budget/import?month=${date}`, data, params)
  createBudget = async params => this.httpClient().post(`planned_budget`, params)
  updateBudget = async (id, params) => this.httpClient().put(`planned_budget/${id}`, params)
  blockRequest = async (params) => this.httpClient().put(`planned_budget/block_request`, params)
  downloadImportIssuesFile = id => this.httpClient().getFile(`planned_budget/import_issue/${id}/get_file`)
})()
